import { KeyRound } from "lucide-react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useState } from "react";

import { api, formatApiError } from "@/lib/api";


export default function ResetPasswordPage() {
  const [password, setPassword] = useState("");
  const [confirmation, setConfirmation] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    setIsSubmitting(true);

    try {
      await api.post("/auth/reset-password", {
        token,
        new_password: password,
        confirm_password: confirmation,
      });
      navigate("/login", { replace: true });
    } catch (requestError) {
      setError(formatApiError(requestError));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <main className="auth-page" data-testid="reset-password-page">
      <section className="auth-panel" aria-labelledby="reset-password-title">
        <p className="eyebrow">ANEKA / PASSWORD</p>
        <KeyRound aria-hidden="true" className="auth-icon" size={28} />
        <h1 id="reset-password-title" data-testid="reset-password-title">Password baru</h1>
        <form className="auth-form" data-testid="reset-password-form" onSubmit={handleSubmit}>
          <label htmlFor="reset-password">Password baru</label>
          <input
            autoComplete="new-password"
            data-testid="reset-password-input"
            id="reset-password"
            minLength="12"
            onChange={(event) => setPassword(event.target.value)}
            required
            type="password"
            value={password}
          />
          <label htmlFor="reset-confirmation">Konfirmasi password baru</label>
          <input
            autoComplete="new-password"
            data-testid="reset-password-confirmation-input"
            id="reset-confirmation"
            minLength="12"
            onChange={(event) => setConfirmation(event.target.value)}
            required
            type="password"
            value={confirmation}
          />
          {error && <p className="form-error" data-testid="reset-password-error" role="alert">{error}</p>}
          <button data-testid="reset-password-submit-button" disabled={isSubmitting || !token} type="submit">
            {isSubmitting ? "Menyimpan…" : "Simpan password"}
          </button>
        </form>
        {!token && <p className="form-error" data-testid="reset-password-token-error">Tautan reset tidak lengkap.</p>}
        <Link data-testid="reset-back-to-login-link" to="/login">Kembali ke masuk</Link>
      </section>
    </main>
  );
}